import { useEffect } from "react";
import { Button, Icon } from "../../components/design";
import styles from "./PermisssionWidget.module.css";

const PermissoWidget = ({ widgetUrl, onClose, onSuccess, onError }) => {
  useEffect(() => {
    const handleMessage = (event) => {
      // Allowing all origins on dev only
      const allowedOrigin = [
        "https://widget.bankflip.io",
        "https://widget.permisso.io",
        "https://widget.sandbox.bankflip.io",
        "https://widget.sandbox.permisso.io",
      ];

      if (!allowedOrigin.includes(event?.origin)) {
        return;
      }

      const data = event?.data;

      if (data?.name === "user_requested_closure") {
        onSuccess && onSuccess(data);
        onClose && onClose();
      } else if (
        ["session_cancelled", "token_expired", "session_expired"].includes(
          data?.name
        )
      ) {
        onError && onError(data);
        onClose && onClose();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onClose, onSuccess, onError]);

  return (
    <div
      className={`popup-overlay wrapper-modal modal-fixed-screen ${styles.widgetOverlay}`}
    >
      <div className={styles.widgetCard}>
        <iframe
          src={widgetUrl}
          className={styles.widgetFrame}
          title="Permisso Widget"
          allow="camera; microphone; clipboard-read; clipboard-write"
        />
        <Button
          variant="ghost"
          size="sm"
          iconOnly
          className={styles.closeButton}
          iconStart={<Icon name="close" size={18} />}
          onClick={() => onClose && onClose()}
          aria-label="Close"
        />
      </div>
    </div>
  );
};

export default PermissoWidget;
